import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { StatusFilterComponent } from './status-filter/status-filter.component';
import { EDrawerComponent } from './e-drawer/e-drawer.component';
import { ETimelineComponent } from './e-timeline/e-timeline.component';
import { EOtpInputComponent } from './e-otp-input/e-otp-input.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    StatusBadgeComponent,
    StatusFilterComponent,
    EDrawerComponent,
    ETimelineComponent,
    EOtpInputComponent
  ],
  exports: [
    StatusBadgeComponent,
    StatusFilterComponent,
    EDrawerComponent,
    ETimelineComponent,
    EOtpInputComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// /app/src/app/components/components.module.ts